import React from 'react';
import { ZeroStateImage } from '../ZeroState.styled';
var defaultImages = {
    searchfilter: 'https://cdn.paylocity.com/cdn/citrus/zerostate/search.svg',
    insufficientdata: 'https://cdn.paylocity.com/cdn/citrus/zerostate/application.svg',
    error: 'https://cdn.paylocity.com/cdn/citrus/zerostate/app-frown.svg',
    takeaction: 'https://cdn.paylocity.com/cdn/citrus/zerostate/file.svg',
    noworkneeded: 'https://cdn.paylocity.com/cdn/citrus/zerostate/check.svg',
    unauthorized: 'https://cdn.paylocity.com/cdn/citrus/zerostate/unauthorized.svg',
};
var Image = function (_a) {
    var type = _a.type, imageUrl = _a.imageUrl, imageClassName = _a.imageClassName, imageCss = _a.imageCss, alt = _a.alt;
    var src = imageUrl !== null && imageUrl !== void 0 ? imageUrl : defaultImages[type];
    return React.createElement(ZeroStateImage, { alt: alt !== null && alt !== void 0 ? alt : '', className: imageClassName || '', css: imageCss, src: src });
};
export default Image;
